module["exports"] = [
  "ახალი",
  "ძველი",
  "ზემო",
  "ქვემო"
];
